<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Create Container</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave" v-if="application">

          <div>
            <label>Type</label>
            <div>
              <md-radio v-model="dataForm.type" value="GENERAL">Loading</md-radio>
              <md-radio v-model="dataForm.type" value="CHECK_POINT">Check Point</md-radio>
            </div>
          </div>

          <md-field>
            <label>CCIC Application No</label>
            <md-input disabled v-model="application.applicationNo"/>
          </md-field>

          <md-field>
            <label>Booking No</label>
            <md-input disabled v-model="application.bookingNo"/>
          </md-field>

          <md-field>
            <label>Po No</label>
            <md-input disabled v-model="application.poNo"/>
          </md-field>
          <md-field>
            <label>Container No</label>
            <md-input v-model="dataForm.containerNo"/>
          </md-field>
          <master-data-select
              label="Grade"
              group="CCIC_GRADE"
              v-model="dataForm.grade"
          />
          <md-field>
            <label>Tare Weight</label>
            <md-input type="number" v-model="dataForm.tareWeight"/>
          </md-field>
          <md-field>
            <label>VGM</label>
            <md-input type="number" v-model="dataForm.vgmWeight"/>
          </md-field>
          <md-field v-if="dataForm.type==='CHECK_POINT'">
            <label>Seal</label>
            <md-input v-model="dataForm.seal"/>
          </md-field>
          <md-field :class="getValidationClass('dataForm.newSeal')">
            <label>New Seal</label>
            <md-input v-model="dataForm.newSeal"/>
            <span class="md-error" v-if="!$v.dataForm.newSeal.required">New Seal is required</span>
          </md-field>
          <div v-if="dataForm.type === 'CHECK_POINT'">
            <!--<label>Status</label>-->
            <div>
              <master-data-select v-model="dataForm.disapprove" group="CCIC_CONTAINER_STATUS" label="Status"/>
              <!--<md-radio v-model="dataForm.disapprove" value="APPROVE">APPROVE</md-radio>-->
              <!--<md-radio v-model="dataForm.disapprove" value="REJECT">REJECT</md-radio>-->
              <!--<md-radio v-model="dataForm.disapprove" value="UNLOAD">UNLOAD</md-radio>-->
              <!--<md-radio v-model="dataForm.disapprove" value="UNLOAD&REJECT">UNLOAD&REJECT</md-radio>-->
            </div>
          </div>
          <md-field v-if="dataForm.type === 'CHECK_POINT'">
            <label>Comment</label>
            <md-textarea v-model="dataForm.disapproveComment"/>
          </md-field>

          <calling-api type="bar" path="/api/w/ccic/container/create">

            <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>

          </calling-api>


        </form>

      </md-dialog-content>
    </md-dialog>
  </div>

</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialDataForm = (type) => ({
    user: null,
    applicationSeqNo: null,
    containerNo: null,
    seal: null,
    newSeal: null,
    type: type || 'GENERAL',
    pickUpLocationId: null,
    pickUpLocationName: null,
    pickUpLatitude: null,
    pickUpLongitude: null,
    refTimeStamp: null,
    disapprove: null,
    disapproveComment: null,
    grade: null,
    tareWeight: null,
    vgmWeight: null,
  });


  export default {
    components: {},
    mixins: [validationMixin],
    data: () => ({
      showDialog: false,
      application: null,
      dataForm: getInitialDataForm(),
    }),
    computed: {
      ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getUserProfile',
      ]),
      getPickupLocationOptions() {
        const { ccicSupplierGroup } = this.getUserProfile;
        if (ccicSupplierGroup) {
          return this.getMasterDataAsSelectOptionByGroup(ccicSupplierGroup);
        }
        return [];
      },
    },
    watch: {
      showDialog(val) {
        if (val === false) {
          this.application = null;
          this.$store.commit('clearApiError');
        }
      },
      'dataForm.type'(val) {
        this.dataForm = getInitialDataForm(val);
        if (val === 'CHECK_POINT') {
          this.dataForm.disapprove = 'APPROVE';
        }
      },
      'dataForm.disapprove'(val) {
        if (val === 'REJECT' || val === 'UNLOAD&REJECT') {
          this.dataForm.newSeal = '';
        }
      },
    },
    validations: {
      dataForm: {
        newSeal: {
          required(val) {
            if (this.dataForm.type === 'CHECK_POINT' && (this.dataForm.disapprove === 'UNLOAD' || this.dataForm.disapprove === 'APPROVE')) {
              return !!val;
            }
            return true;
          },
        },
      },
    },
    methods: {
      openDialog(application) {
        this.dataForm = getInitialDataForm();
        this.application = application;
        this.$v.dataForm.$reset();
        this.showDialog = true;
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      doSave() {
        this.$v.dataForm.$touch();
        console.log(this.$v.dataForm.$invalid);
        if (this.$v.dataForm.$invalid) {
          return;
        }

        this.dataForm.user = this.application.user;
        this.dataForm.applicationSeqNo = this.application.seqNo;
        console.log(JSON.stringify(this.dataForm));

        //api.post("/api/w/ccic/container/create", this.dataForm)
        newAPIPost("/api/w/ccic/container/create", this.dataForm)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
          });
      },
    },
  };


</script>
